import { render, staticRenderFns } from "./Pagetitle.vue?vue&type=template&id=0db7d1f2&"
import script from "./Pagetitle.vue?vue&type=script&lang=js&"
export * from "./Pagetitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports